'use client';

import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Link from 'next/link';

export default function FeaturesPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900">
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Powerful features for{' '}
            <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent">
              every video workflow
            </span>
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Everything you need to search, clip, and analyze your video content with AI
          </p>
        </div>
      </section>

      {/* Features Grid */}
      <section className="pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: 'AI-Powered Search',
                description: 'Search across all your videos using natural language. Find "How to build a React app" across thousands of hours instantly.',
                icon: '🔍',
                features: ['Natural language queries', 'Semantic understanding', 'Instant results']
              },
              {
                title: 'Smart Clip Detection',
                description: 'Automatically detect the perfect clip boundaries with 99% accuracy using AI and existing question data.',
                icon: '✂️',
                features: ['Automatic detection', 'Context-aware', '99% accuracy']
              },
              {
                title: 'Batch Processing',
                description: 'Upload and process multiple videos simultaneously with intelligent queuing and progress tracking.',
                icon: '⚡',
                features: ['Multiple videos', 'Progress tracking', 'Queue management']
              },
              {
                title: 'Advanced Analytics',
                description: 'Track engagement, view popular questions, and understand viewer behavior across all your content.',
                icon: '📊',
                features: ['View analytics', 'Trend analysis', 'Export reports']
              },
              {
                title: 'API Access',
                description: 'Integrate Reclipt into your existing workflow with our powerful REST API.',
                icon: '🔌',
                features: ['REST API', 'Webhooks', 'SDKs']
              },
              {
                title: 'Export & Share',
                description: 'Export clips in any format, share directly to social media, or download for offline use.',
                icon: '📤',
                features: ['Multiple formats', 'Social sharing', 'Direct download']
              }
            ].map((feature, idx) => (
              <div 
                key={idx}
                className="bg-gray-800/50 backdrop-blur-sm p-8 rounded-xl border border-gray-700 hover:border-blue-500/50 transition group"
              >
                <div className="text-5xl mb-4">{feature.icon}</div>
                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-blue-400 group-hover:to-cyan-400 group-hover:bg-clip-text transition">
                  {feature.title}
                </h3>
                <p className="text-gray-400 mb-4">{feature.description}</p>
                <ul className="space-y-2">
                  {feature.features.map((f, i) => (
                    <li key={i} className="flex items-center text-sm text-gray-300">
                      <span className="text-blue-500 mr-2">→</span>
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div className="mt-20 text-center">
            <h2 className="text-3xl font-bold text-white mb-6">
              Ready to try it yourself?
            </h2>
            <Link
              href="/register"
              className="inline-block bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-10 py-5 rounded-lg text-xl font-semibold hover:from-blue-700 hover:to-cyan-700 transition shadow-lg shadow-blue-500/50"
            >
              Start Free Trial
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

